<template>
  <div v-if="syncStats" class="mb-4 p-3 sm:p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
    <div class="flex items-center justify-between mb-3">
      <div class="flex items-center gap-2">
        <InfoIcon class="h-5 w-5 text-yellow-600 flex-shrink-0" />
        <span class="text-sm font-medium text-yellow-800">{{
          $t('translation.sync.stats.title')
        }}</span>
      </div>
      <button
        @click="$emit('close')"
        class="text-yellow-600 hover:text-yellow-800 transition-colors"
        :aria-label="$t('translation.filters.reset')"
      >
        <XIcon class="h-4 w-4" />
      </button>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
      <div class="bg-white p-2 rounded border">
        <div class="font-medium text-gray-900">{{ $t('translation.sync.stats.frontend') }}</div>
        <div class="text-gray-600">
          {{ syncStats.frontendKeys }} {{ $t('translation.sync.stats.frontendKeys') }}
        </div>
      </div>
      <div class="bg-white p-2 rounded border">
        <div class="font-medium text-gray-900">{{ $t('translation.sync.stats.backend') }}</div>
        <div class="text-gray-600">
          {{ syncStats.backendKeys }} {{ $t('translation.sync.stats.backendKeys') }}
        </div>
      </div>
      <div class="bg-white p-2 rounded border">
        <div class="font-medium text-gray-900">{{ $t('translation.sync.stats.difference') }}</div>
        <div :class="syncStats.missingKeys > 0 ? 'text-orange-600 font-medium' : 'text-green-600'">
          {{
            syncStats.missingKeys > 0
              ? `${syncStats.missingKeys} ${$t('translation.sync.stats.missing')}`
              : $t('translation.sync.stats.synced')
          }}
        </div>
      </div>
    </div>
    <div
      v-if="syncStats.missingKeys > 0"
      class="mt-3 p-3 bg-orange-50 border border-orange-200 rounded"
    >
      <div class="text-sm text-orange-800">
        <div class="font-medium mb-1">{{ $t('translation.sync.stats.recommendations') }}</div>
        <div class="text-xs">
          • {{ $t('translation.sync.stats.recommendationText', { count: syncStats.missingKeys }) }}
          <br />
          • {{ $t('translation.sync.stats.recommendationText2') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { InfoIcon, XIcon } from 'lucide-vue-next'

interface SyncStats {
  frontendKeys: number
  backendKeys: number
  missingKeys: number
}

interface Props {
  syncStats: SyncStats | null
}

defineProps<Props>()
defineEmits<{
  close: []
}>()
</script>
